import { useEffect } from 'react';
import { checkIsOnlyMainItem } from '../../../../../../components/menu/products/extras/ui/AddExtrasFormDialog';
import { ProductType } from '../../../../../../components/menu/products/ItemsContainer';
import { AdvancedChecklistStateType } from './state/AdvancedChecklist';

const useAdvancedChecklist = (
    state: AdvancedChecklistStateType,
    setListData: (list: any[]) => void,
    searchKey: string,
    disableItemTypeSelection?: ProductType,
) => {
    const { listItems, filtersList, selectedFiltersIDs } = state;

    useEffect(() => {
        applyFilters();
        // eslint-disable-next-line
    }, [state.selectedFiltersIDs]);

    const applyFilters = () => {
        const filterKey = filtersList[0]?.itemFilterKey;
        listItems.forEach((item) => {
            if (selectedFiltersIDs?.length > 0 && !selectedFiltersIDs.includes(item[filterKey])) {
                item.filterHidden = true;
            } else {
                item.filterHidden = false;
            }
        });
        setListData([...listItems]);
    };

    const selectAll = () => {
        listItems.forEach((item) => {
            let flag = true;
            if (disableItemTypeSelection) {
                const mainItem = checkIsOnlyMainItem(item);
                if (
                    (disableItemTypeSelection === ProductType.MainItem && mainItem) ||
                    (disableItemTypeSelection === ProductType.ExtraItem && !mainItem)
                ) {
                    flag = false;
                }
            }
            if (!item.hidden && !item.filterHidden && flag) {
                item.selected = true;
            }
        });
        setListData([...listItems]);
    };

    const selectNone = () => {
        listItems.forEach((item) => {
            if (!item.hidden && !item.filterHidden) {
                item.selected = false;
            }
        });
        setListData([...listItems]);
    };

    const getSelected = () => {
        const selectedItems = listItems.filter((item) => item.selected);
        return selectedItems;
    };

    const onSearchChange = (value: string) => {
        const tempItems = listItems.map((item) => {
            if (item[searchKey]?.toLowerCase()?.indexOf(value.toLowerCase()) > -1) {
                return {
                    ...item,
                    hidden: false,
                };
            }
            return { ...item, hidden: true };
        });
        setListData(tempItems);
    };

    const getSelectedCount = () => {
        const count = listItems.filter((item) => item.selected).length;
        return count;
    };

    return {
        selectAll,
        selectNone,
        getSelected,
        onSearchChange,
        getSelectedCount,
    };
};

export default useAdvancedChecklist;
